import { Injectable } from '@angular/core';

import dayjs from 'dayjs';

import { TimeEntity } from '@zeusm/business/core/entities';

@Injectable()
export class DateFilterService {
  get availableFilters(): TimeEntity[] {
    return [
      {
        id: 0,
        name: 'business.core.dateFilter.option.today',
        from: this.#startOfToday,
        to: this.#endOfToday,
      },
      {
        id: 1,
        name: 'business.core.dateFilter.option.yesterday',
        from: this.#startOfToday.subtract(1, 'd'),
        to: this.#endOfToday.subtract(1, 'd'),
      },
      {
        id: 2,
        name: 'business.core.dateFilter.option.lastSevenDays',
        from: this.#startOfToday.subtract(6, 'd'),
        to: this.#endOfToday,
      },
      {
        id: 3,
        name: 'business.core.dateFilter.option.lastThirtyDays',
        from: this.#startOfToday.subtract(29, 'd'),
        to: this.#endOfToday,
      },
      {
        id: 4,
        name: 'business.core.dateFilter.option.thisMonth',
        from: this.#startOfToday.startOf('month'),
        to: this.#endOfToday,
      },
      {
        id: 5,
        name: 'business.core.dateFilter.option.lastMonth',
        from: this.#prevMonth.startOf('month'),
        to: this.#prevMonth.endOf('month'),
      },
    ];
  }

  get #prevMonth(): dayjs.Dayjs {
    return dayjs().subtract(1, 'month');
  }

  get #startOfToday(): dayjs.Dayjs {
    return dayjs().startOf('d');
  }

  get #endOfToday(): dayjs.Dayjs {
    return dayjs().endOf('d');
  }

  getFilterObjById(id: number): TimeEntity {
    return this.availableFilters.find(filter => filter.id === id);
  }

  adaptDateEndForApi(start: number, end: number): number {
    if (!start) {
      return null;
    }

    const dateEnd = dayjs.unix(end || start);
    const dateEndInclusive = dateEnd.endOf('d');

    return dateEndInclusive.unix();
  }
}
